import { h, Fragment } from "preact";
import ProductOptionPill from "./product-option-pill";
import ProductOptionSummary from "./product-option-summary";

export default function ProductOptionPills({
  optionValues,
  optionName,
  updateOptionValue,
  selectedOptionValue,
  disabledOptionValues = [],
  openByDefault,
  last,
}) {
  const maxValueLength = Math.max(
    ...optionValues.map((optionValue) => optionValue.name.length),
  );
  const maxColumns = maxValueLength > 15 ? 2 : maxValueLength > 10 ? 3 : 4;
  const pillColumns = Math.min(optionValues.length, maxColumns);

  return (
    <conditional-details>
      <details
        className={`product-options__option-details ${last ? "product-options__option-details--last" : ""} product-options__pills`}
        open={openByDefault}
      >
        <ProductOptionSummary
          optionName={optionName}
          selectedOptionValue={selectedOptionValue}
          optionValuesCount={optionValues.length}
        />
        <div className="product-options__option-content" data-content>
          <div className="product-options__option-content-inner">
            <fieldset
              className="product-options__pill-list"
              style={{ "--pill-columns": pillColumns }}
            >
              <legend class="visually-hidden">{optionName}</legend>
              {optionValues.map((optionValue) => (
                <ProductOptionPill
                  key={optionValue.name}
                  optionValue={optionValue}
                  optionName={optionName}
                  disabled={disabledOptionValues.includes(optionValue.name)}
                  updateOptionValue={updateOptionValue}
                  selected={optionValue.name === selectedOptionValue}
                />
              ))}
            </fieldset>
          </div>
        </div>
      </details>
    </conditional-details>
  );
}
